import CarsList from "../../components/CarList/CarList"
import { Container } from "react-bootstrap"

const CarsListPage = () => {

    return (

        <Container>

            <h1>Lista de coches</h1>

            <hr />

            <CarsList />

        </Container>

    )
}

export default CarsListPage
